import { render } from "./ServiceArea.vue?vue&type=template&id=49843220&scoped=true"
import script from "./ServiceArea.vue?vue&type=script&lang=js"
export * from "./ServiceArea.vue?vue&type=script&lang=js"

import "./ServiceArea.vue?vue&type=style&index=0&id=49843220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49843220"]])

export default __exports__